import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_API_BASE_URL;

// Request account deletion → sends OTP
export const requestAccountDeletionApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.AccountDeletion.requestApi}`, data || {})
    .catch((err) => err.response);
  return setCurrentUser(res);
};

// Verify OTP & delete account
export const verifyAccountDeletionApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.AccountDeletion.verifyApi}`, data || {})
    .catch((err) => err.response);
  return setCurrentUser(res);
};
